const DEFAULT_SETTINGS = {
  /*
  fieldId: { // Same ID as supplied to <Input />
    value: '',
    defaultValue: '', // Update StepReview.jsx & relevant step(s) if you need to output
  }
  */
  /* Default Advanced Settings */
  awsCloudTrailThrottleEnabled: {
    value: true
    // We want to default to true on render, but never compare the default
  },
  overrideSource: {
    value: ""
  },
  pollingInterval: {
    value: 1
  },
  sqsMessageBatchSize: {
    value: 5
  },
  includeFullMessageJson: {
    value: false
  }
};
export default DEFAULT_SETTINGS;
